// @ts-nocheck
import {Column} from 'react-table'
import {InfoCellName} from './InfoCell'
import {ActionsCell} from './ActionsCell'
import {CustomHeader} from './CustomHeader'
import {Model} from '../../core/_models'

const objsColumns: ReadonlyArray<Column<Model>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='IVR Code' className='min-w-125px' />,
    id: 'ivrCode',
    accessor: 'ivrCode',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='IVR Value' className='min-w-125px' />,
    accessor: 'ivrValue',
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => (
      <ActionsCell
        customerIVRID={props.data[props.row.index].customerIVRID}
        code={props.data[props.row.index].ivrCode}
        value={props.data[props.row.index].ivrValue}
      />
    ),
  },
]

export {objsColumns}

